import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=2b2d9a06&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"
import style0 from "./Time.vue?vue&type=style&index=0&id=2b2d9a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d9a06",
  null
  
)

export default component.exports